import React, { useCallback, useEffect, useLayoutEffect, useState } from 'react'
import { Col, message, notification, Row } from 'antd'
import { ProjectionControlTable } from './components'
import {
  DownloadModal,
  FavouriteEditModal,
  PreferencesTableModal,
  ProgressBar,
} from 'modules/core/components'
import { TableActions } from './components/ProjectionControlTable/components'
import { INTEGRATIONS, TABLES } from 'modules/core/constants'
import { connect } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { handleDelete, handleDeleteRow, handleSave, handleSavePrimary } from './utils'
import moment from 'moment'
import login from 'modules/login'
import control from 'modules/control'
import configuration from 'modules/configuration'
import _, { isEqual } from 'lodash'
import { normalizeFilters } from 'modules/core/utils/normalize-filters'
import {
  generateMessageError,
  getHashTable,
  sendUserDataToGTM,
  setFormatNumber,
} from 'modules/core/utils'
import TSVExport from 'components/PivotTable/Renderers/Base/TSVExport'
import { useFeatureIsOn, useFeatureValue } from '@growthbook/growthbook-react'
import PivotTableRenderers from 'components/PivotTable/Renderers/Base/Tree'
import PlaneTableRenderers from 'components/PivotTable/Renderers/Base/Plane'
import { Prompt } from 'react-router-dom'

const DEFAULT_FORMAT_CREATE = {
  'Suma (Decimales)': 'float',
  'Suma (Enteros)': 'int',
  'Suma (Miles)': 't',
  'Suma (Millones)': 'm',
}

const DEFAULT_FORMAT_SET = {
  float: 'Suma (Decimales)',
  int: 'Suma (Enteros)',
  t: 'Suma (Miles)',
  m: 'Suma (Millones)',
}

const getRowAuxName = (rows, allDimensionsList) => {
  return rows.map((row) => {
    const dimension = allDimensionsList.find((el) => parseInt(row) === el.id)
    if (dimension) {
      return dimension.name_origin
    } else {
      if (row === 'Moneda Origen') {
        return 'Moneda Origen'
      }
      if (row === 'Fecha') {
        return 'Fecha'
      }
      return ''
    }
  })
}

const getColsAuxName = (columns, allDimensionsList) => {
  return columns.map((col) => {
    if (col === 'Fecha') {
      return 'Fecha'
    } else if (col === 'Moneda Origen') {
      return 'Moneda Origen'
    } else {
      const dimension = allDimensionsList.find((el) => parseInt(col) === el.id)
      return dimension ? dimension.name_origin : ''
    }
  })
}

const getRowAuxId = (settings, allDimensionsList) => {
  return (
    !_.isEmpty(settings) &&
    settings.rows.map((row) => {
      const id = allDimensionsList.find((el) => el.name_origin === row)
        ? allDimensionsList.find((el) => el.name_origin === row).id
        : null
      if (row === 'Moneda Origen') {
        return 'Moneda Origen'
      } else if (row === 'Fecha') {
        return 'Fecha'
      } else {
        return id.toString()
      }
    })
  )
}

const getColsAuxId = (settings, allDimensionsList) => {
  return (
    !_.isEmpty(settings) &&
    settings.cols.map((col) => {
      const id = allDimensionsList.find((el) => el.name_origin === col)
        ? allDimensionsList.find((el) => el.name_origin === col).id
        : null
      if (col === 'Fecha') {
        return 'Fecha'
      } else if (col === 'Moneda Origen') {
        return 'Moneda Origen'
      } else {
        return id.toString()
      }
    })
  )
}

const Evolution = ({
  dataSource,
  isTableLoading,
  onRefresh,
  conceptId,
  conceptName,
  dataPeriod,
  periodId,
  setTablePagination,
  setDataSelection,
  canUserUpload,
  isProgressLoading,
  showProgressBar,
  loggedUser,
  downloadProjectionXLS,
  createLayout,
  fetchLayoutList,
  layoutList,
  fetchAllDimensions,
  allDimensionsList,
  deleteTransactionFilter,
  deleteLayout,
  hasComment,
  setHasComment,
  fetchCommentsList,
  commentsList,
  createComment,
  removeNewComment,
  currencyData,
  downloadProjectionExcel,
  downloadProjectionParquet,
  activeTab,
  showTableqp,
  setShowTableqp,
  settings,
  setSettings,
  downloadControlTableTsv,
}) => {
  const enableDownloadTSVReales = useFeatureIsOn('enable-download-tsv-reales')
  const enabledPlaneTable = useFeatureIsOn('feature-plane-table')
  const enableFormatNumber = useFeatureIsOn('enable-format-number')
  const formatBaseNumber = useFeatureValue('format-number-table', 'Suma (Decimales)')
  const [showModal, setShowModal] = useState(false)
  const [showEdit, setShowEdit] = useState(false)
  const [tableSettings, setTableSettings] = useState({
    ...TABLES.DEFAULT_SETTINGS,
    negativeValuesType: TABLES.NEGATIVE_VALUES_TYPES.NORMAL,
    showNegativeInRed: false,
  })
  const [isDeleting, setIsDeleting] = useState(false)
  const [dataDelete, setDataDelete] = useState({})
  const [showPopover, setShowPopover] = useState(false)
  const [favouriteName, setFavouriteName] = useState('')
  const [isSaving, setIsSaving] = useState(false)
  const [isLayoutLoading, setIsLayoutLoading] = useState(false)
  const [viewSelect, setViewSelect] = useState({})
  const [viewComment, setViewComment] = useState(false)
  const [dataComments, setDataComments] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [isCommentSaving, setIsCommentSaving] = useState(false)
  const [showModalEdit, setShowModalEdit] = useState(false)
  const [newName, setNewName] = useState('')
  const [rowId, setRowId] = useState(null)
  const [hash, setHash] = useState(null)
  const [showPreferenceModal, setShowPreferenceModal] = useState(false)
  const [exist, setExist] = useState(false)
  const [dataLocalStorage, setDataLocalStorage] = useState(localStorage.getItem('dataTable'))

  const { t } = useTranslation()

  const key = window.location.pathname.replaceAll('/', '-')

  var queryString = window.location.search
  var urlParams = new URLSearchParams(queryString)
  var table = urlParams.get('table')
  var url_hash = urlParams.get('hash_url')

  useEffect(() => {
    const onCustom = (e) => {
      if (e?.detail?.key === 'dataTable') setDataLocalStorage(e.detail.value)
    }

    window.addEventListener('local-storage', onCustom)
    return () => {
      window.removeEventListener('local-storage', onCustom)
    }
  }, [])

  useEffect(() => {
    if (!dataLocalStorage && !url_hash && layoutList.values.length === 0) {
      setSettings({})
    }

    const dataTable = JSON.parse(dataLocalStorage)

    if (dataLocalStorage && allDimensionsList.length > 0 && !url_hash) {
      setSettings((prevstate) => {
        return {
          ...prevstate,
          ...dataTable,
          hiddenFromDragDrop: ['amount', 'price', 'quantity'],
        }
      })

      const dataFormat = dataTable
        ? {
            row_order: 0,
            column_order: 1,
            default_value: dataTable.vals[0],
            default_format: DEFAULT_FORMAT_CREATE[dataTable.aggregatorName],
            rows: getRowAuxId(dataTable, allDimensionsList),
            columns: getColsAuxId(dataTable, allDimensionsList),
          }
        : {}

      const data = layoutList.values
        .filter((el) => !el.url_hash)
        .find((el) => _.isEqual(el.config, dataFormat))

      if (data) {
        setViewSelect(data)
        setExist(true)
      } else {
        setExist(false)
        const aux = layoutList.values.filter((el) => !el.url_hash).find((el) => el.primary)
        setViewSelect(aux)
      }
    }

    const layoutsUrlHash = layoutList.values.filter((el) => el.url_hash)

    if (url_hash && !dataTable && layoutsUrlHash.length > 0 && allDimensionsList.length > 0) {
      setSettings((prevstate) => {
        return {
          ...prevstate,
          ...layoutsUrlHash[0].config,
          hiddenFromDragDrop: ['amount', 'price', 'quantity'],
        }
      })

      const dataFormat = {
        row_order: 0,
        column_order: 1,
        default_value: layoutsUrlHash[0].config.vals[0],
        default_format: DEFAULT_FORMAT_CREATE[layoutsUrlHash[0].config.aggregatorName],
        rows: getRowAuxId(layoutsUrlHash[0].config, allDimensionsList),
        columns: getColsAuxId(layoutsUrlHash[0].config, allDimensionsList),
      }

      const data2 = layoutList.values
        .filter((el) => !el.url_hash)
        .find((el) => _.isEqual(el.config, dataFormat))

      if (data2) {
        setViewSelect(data2)
        setExist(true)
      } else {
        setExist(false)
        const aux = layoutList.values.filter((el) => !el.url_hash).find((el) => el.primary)
        setViewSelect(aux)
      }
    }
  }, [dataLocalStorage, allDimensionsList, url_hash, layoutList.values])

  useEffect(() => {
    if (table) {
      const data = !isEqual(hash, table) && hash !== null ? hash : table
      const json = Buffer.from(data, 'base64').toString()
      const dataTable = JSON.parse(json)
      setSettings((prevstate) => {
        return {
          ...prevstate,
          ...dataTable.config,
          hiddenFromDragDrop: ['amount', 'price', 'quantity'],
        }
      })
    }
  }, [table, hash])

  useEffect(() => {
    const { data, ...restProps } = settings
    if (!_.isEmpty(restProps) && showTableqp) {
      window.history.replaceState(
        null,
        '',
        `/seguimiento/${periodId}/${conceptName}/${conceptId}/${currencyData?.id}/${activeTab}`, //?table=${getHashTable(settings)}`,
      )
    }
  }, [settings, periodId, conceptId, conceptName, activeTab, currencyData, showTableqp])

  useEffect(() => {
    setIsLoading(true)
    fetchCommentsList({ module: key }).then(() => setIsLoading(false))
  }, [fetchCommentsList, key])

  useEffect(() => {
    setDataComments(commentsList)
  }, [commentsList])

  useEffect(() => {
    setIsLayoutLoading(true)
    const endpointParam = { ...(url_hash && { url_hash }) }
    fetchLayoutList('real', `${periodId}-${conceptId}`, endpointParam).then(() => {
      setIsLayoutLoading(false)
      // !table && setSettings({})
    })
  }, [fetchLayoutList, periodId, conceptId, table, url_hash])

  useEffect(() => {
    fetchAllDimensions()
  }, [fetchAllDimensions])

  useEffect(() => {
    const defaultLayout = layoutList.values.filter((el) => !el.url_hash).find((el) => el.primary)
    if (!dataLocalStorage) {
      setViewSelect(defaultLayout)
    }
  }, [layoutList.values, dataLocalStorage])

  useEffect(() => {
    if (
      layoutList.values.filter((el) => !el.url_hash).length > 0 &&
      !_.isEmpty(viewSelect) &&
      allDimensionsList.length > 0 &&
      !table &&
      !url_hash &&
      !localStorage.getItem('dataTable')
    ) {
      setSettings((prevState) => {
        return {
          ...prevState,
          ...viewSelect.config,
          hiddenFromDragDrop: ['amount', 'price', 'quantity'],
          cols:
            getColsAuxName(viewSelect.config.columns, allDimensionsList).length > 0
              ? getColsAuxName(viewSelect.config.columns, allDimensionsList)
              : ['Fecha'],
          rows: getRowAuxName(viewSelect.config.rows, allDimensionsList),
          aggregatorName: DEFAULT_FORMAT_SET[viewSelect.config.default_format],
          vals: [viewSelect.config.default_value],
        }
      })
    }
  }, [allDimensionsList, layoutList.values, viewSelect, table, url_hash])

  useEffect(() => {
    setDataDelete(settings.tableFilter)
  }, [settings.tableFilter])

  const handleCreate = ({ text, usersIds, idComment = null, setIsNewThread }) => {
    const dataa = {
      text,
      key: `${key}-table-evolution`,
      module: key,
      mentions: usersIds,
      ...(idComment && {
        parent: idComment,
      }),
    }
    setIsCommentSaving(true)
    createComment(dataa)
      .then(() =>
        fetchCommentsList({ module: key }).then(() => {
          message.success(t('FEEDBACK_SAVE_CHANGES_SUCCES'), 8)
          setIsCommentSaving(false)
          setIsNewThread(false)
        }),
      )
      .catch((error) => {
        message.error(generateMessageError(error, 'FEEDBACK_SAVE_CHANGES_FAIL_MESSAGE'), 8)
        setIsCommentSaving(false)
        setIsNewThread(false)
      })
  }

  const onCloseDeleteRow = () => {
    setIsDeleting(false)
    setDataSelection([])
    setTablePagination({ current: 1 })
  }

  const onCreate = () => {
    const data = {
      row_order: 0,
      column_order: 1,
      default_value: settings.vals[0],
      default_format: DEFAULT_FORMAT_CREATE[settings.aggregatorName],
      rows: getRowAuxId(settings, allDimensionsList),
      columns: getColsAuxId(settings, allDimensionsList),
    }

    return createLayout('real', `${periodId}-${conceptId}`, favouriteName, { config: data })
  }

  const onClose = () => {
    setIsSaving(false)
    setShowPopover(false)
    setFavouriteName('')
  }

  const defaultData = !_.isEmpty(viewSelect) && {
    ...viewSelect.config,
    rows: getRowAuxName(viewSelect.config.rows, allDimensionsList),
    columns: getColsAuxName(viewSelect.config.columns, allDimensionsList),
    default_format: DEFAULT_FORMAT_SET[viewSelect.config.default_format],
  }
  const defaultSettings = !_.isEmpty(settings) && {
    rows: settings.rows,
    columns: settings.cols || ['Fecha'],
    row_order: settings.row_order,
    column_order: settings.column_order,
    default_value: settings.vals ? settings.vals[0] : '',
    default_format: settings.aggregatorName,
  }

  const onSavePrimary = (data) => {
    const dataAux = layoutList.values
      .filter((el) => !el.url_hash)
      .find((el) => el.name === data.name)
    return createLayout('real', `${periodId}-${conceptId}`, dataAux.name, {
      ...dataAux,
      primary: true,
    })
  }

  const getFileName = () => {
    return t('CONTROL_MENSUAL_EVOLUTION_FILE_NAME', {
      name: conceptName,
      period: dataPeriod.name,
      date: moment().format('lll'),
    })
  }

  const renderCanSave = () => {
    const { data, ...rest } = settings
    return !_.isEmpty(rest) || (!_.isEmpty(rest) && !_.isEqual(defaultData, defaultSettings))
  }

  const getAlreadyExist = () => {
    if (table) {
      const dataHash = !isEqual(hash, table) && hash !== null ? hash : table
      const json = Buffer.from(dataHash, 'base64').toString()
      const dataTable = JSON.parse(json)
      const { columns, cols, aggregatorName, rows, default_value, vals, default_format } =
        dataTable.config
      const data = layoutList.values
        .filter((el) => !el.url_hash)
        .find((el) => {
          const { column_order, row_order, ...restProps } = el.config
          const dataConfig = {
            ...restProps,
            rows: getRowAuxName(restProps.rows, allDimensionsList),
            columns: getColsAuxName(restProps.columns, allDimensionsList),
          }
          return _.isEqual(
            {
              columns: columns ? columns : cols,
              rows,
              default_value: default_value ? default_value : vals[0],
              default_format: default_format
                ? default_format
                : DEFAULT_FORMAT_CREATE[aggregatorName],
            },
            dataConfig,
          )
        })

      if (data) {
        const { column_order, row_order, ...restProps } = data.config

        const filterData = {
          ...restProps,
          rows: getRowAuxName(restProps.rows, allDimensionsList),
          columns: getColsAuxName(restProps.columns, allDimensionsList),
        }

        return _.isEqual(
          {
            columns: columns ? columns : cols,
            rows,
            default_value: default_value ? default_value : vals[0],
            default_format: default_format ? default_format : DEFAULT_FORMAT_CREATE[aggregatorName],
          },
          filterData,
        )
      } else {
        return false
      }
    } else {
      return _.isEqual(defaultData, defaultSettings)
    }
  }

  function getTSV(dataTable, settings) {
    const { data, ...rest } = settings

    const dataSetting = {
      ...(!_.isEmpty(rest)
        ? {
            ...settings,
          }
        : {
            renderers: enabledPlaneTable
              ? Object.assign({}, PlaneTableRenderers)
              : Object.assign({}, PivotTableRenderers),
            onChange: (s) => {
              setSettings(s)
              setShowTableqp(true)
              setHash(getHashTable(s))
            },
            numberFormat: (val) => (enableFormatNumber ? setFormatNumber(loggedUser, val) : val),
            vals: settings.default_value ? [settings.default_value] : ['amount'],
            cols: dataSource.fields.columns,
            rows: dataSource.fields.rows_default,
            aggregatorName: settings.default_format || formatBaseNumber,
            hiddenFromDragDrop: dataSource.fields.values,
            hiddenFromAggregators:
              dataSource[0] && dataSource[0].filter((el) => !dataSource.fields.values.includes(el)),
            tableOptions: {
              realMonths: dataSource.fields?.real_months,
              clickCallback: (info, value, record, pivotData, vals) => {},
            },
            plotlyConfig: {
              responsive: true,
            },
            tableFilter: {},
            colOrder: 'key_a_to_z',
            derivedAttributes: {},
            hiddenAttributes: [],
            rendererName: 'Table',
            rowOrder: 'key_a_to_z',
            sorters: {},
            valueFilter: {},
          }),
    }

    const auxDataTable = {
      data: dataTable,
      ...dataSetting,
    }

    const textAreaElement = new TSVExport(auxDataTable).render()
    const tsv = textAreaElement.props.value

    const blob = new Blob([tsv], { type: 'text/tab-separated-values' })
    const file = new File([blob], 'pivot.tsv', { type: 'text/tab-separated-values' })

    downloadControlTableTsv(file, { concept: conceptName }, getFileName())
  }

  const downloadDataRealesExcel = () => {
    if (enableDownloadTSVReales) {
      return getTSV(dataSource.data, settings)
    } else {
      return downloadProjectionExcel(
        getFileName(),
        {
          period_id: periodId,
          date_start: moment(dataPeriod.start_date).format('YYYY-MM-DD'),
          date_end: moment(dataPeriod.end_date).format('YYYY-MM-DD'),
        },
        {
          concept_id: conceptId,
        },
      )
    }
  }

  const renderTableActions = () => (
    <TableActions
      setTableSettings={setTableSettings}
      tableSettings={tableSettings}
      columns={dataSource?.fields?.columns}
      onClickDownloadSpreadsheets={() => setShowModal(true)}
      onClickDownload={() => {
        downloadProjectionXLS(
          t('CONTROL_MENSUAL_EVOLUTION_FILE_NAME', {
            name: conceptName,
            period: dataPeriod.name,
            date: moment().format('lll'),
          }),
          {
            period_id: periodId,
            date_start: moment(dataPeriod.start_date).format('YYYY-MM-DD'),
            date_end: moment(dataPeriod.end_date).format('YYYY-MM-DD'),
          },
          {
            concept_id: conceptId,
          },
        )
        sendUserDataToGTM(loggedUser, 'Seguimiento', 'Descargar reales', 'Descarga')
      }}
      dataDelete={dataDelete}
      onConfirmDelete={() =>
        handleDeleteRow({
          setIsLoading: setIsDeleting,
          deleteRow: () =>
            deleteTransactionFilter(
              periodId,
              conceptId,
              normalizeFilters(allDimensionsList, dataDelete),
            ),
          onRefetch: onRefresh,
          onClose: onCloseDeleteRow,
          sendUserDataToGTM: () =>
            sendUserDataToGTM(loggedUser, 'Seguimiento', 'Eliminar fila reales', 'Eliminación'),
        })
      }
      isDeleting={isDeleting}
      disabled={!canUserUpload}
      onClickSaveFav={() => setShowPopover(true)}
      visibleFav={showPopover}
      onClickSave={() =>
        handleSave({
          setIsLoading: setIsSaving,
          createLayout: () => onCreate(),
          onRefetch: () => fetchLayoutList('real', `${periodId}-${conceptId}`),
          onRefresh,
          onClose,
        })
      }
      onClickCancelSaveFav={onClose}
      setFavouriteName={setFavouriteName}
      favouriteName={favouriteName}
      isLoading={isSaving}
      hasFavourite={layoutList.values.filter((el) => !el.url_hash).length > 0}
      options={layoutList.values
        .filter((el) => !el.url_hash)
        .map((el) => {
          return { name: el.name, id: el.name, primary: el.primary }
        })}
      canSave={renderCanSave()}
      viewSelect={viewSelect}
      setViewSelect={(val) => {
        const aux = layoutList.values.filter((el) => !el.url_hash).find((el) => el.name === val)
        const dataTable = {
          ...aux.config,
          hiddenFromDragDrop: ['amount', 'price', 'quantity'],
          cols:
            getColsAuxName(aux.config.columns, allDimensionsList).length > 0
              ? getColsAuxName(aux.config.columns, allDimensionsList)
              : ['Fecha'],
          rows: getRowAuxName(aux.config.rows, allDimensionsList),
          aggregatorName: DEFAULT_FORMAT_SET[aux.config.default_format],
          vals: [aux.config.default_value],
        }
        getHashTable(dataTable)
        setViewSelect(aux)
      }}
      alreadyExist={getAlreadyExist() || exist}
      layoutLoading={isLayoutLoading}
      setPrimary={(data) =>
        handleSavePrimary({
          setIsLoading: setIsSaving,
          createLayout: () => onSavePrimary(data),
          onRefetch: () => fetchLayoutList('real', `${periodId}-${conceptId}`),
          onClose: () => setIsSaving(false),
        })
      }
      onClickDeleteFav={(name) =>
        handleDelete({
          setIsLoading: setIsSaving,
          deleteLayout: () => deleteLayout('real', `${periodId}-${conceptId}`, name),
          onRefetch: () => fetchLayoutList('real', `${periodId}-${conceptId}`),
          onClose: () => setIsSaving(false),
        })
      }
      showComments={
        viewComment ||
        dataComments.filter((el) => el.key === `${key}-table-evolution` && !el.resolved).length > 0
      }
      hasComment={hasComment}
      setHasComment={setHasComment}
      setViewComment={setViewComment}
      userDetail={loggedUser}
      settings={settings}
      setDataComments={setDataComments}
      comments={dataComments.filter(
        (el) => (el.key === `${key}-table-evolution` && !el.resolved) || !el.text,
      )}
      onRefetchComments={() => fetchCommentsList({ module: key })}
      loading={isLoading || isCommentSaving}
      onCommentCreate={(text, usersIds, idComment, setIsNewThread) =>
        handleCreate({ text, usersIds, idComment, setIsNewThread })
      }
      removeNewComment={removeNewComment}
      currencyData={currencyData}
      onDownloadExcel={() => {
        downloadDataRealesExcel()
        sendUserDataToGTM(loggedUser, 'Seguimiento', 'Descargar reales excel', 'Descarga')
      }}
      onDownloadParquet={() => {
        downloadProjectionParquet(
          getFileName(),
          {
            period_id: periodId,
            date_start: moment(dataPeriod.start_date).format('YYYY-MM-DD'),
            date_end: moment(dataPeriod.end_date).format('YYYY-MM-DD'),
          },
          {
            concept_id: conceptId,
          },
        )
        sendUserDataToGTM(loggedUser, 'Seguimiento', 'Descargar reales parquet', 'Descarga')
      }}
      onClickEditNameFav={() => setShowModalEdit(true)}
      onClckPreferences={() => setShowPreferenceModal(true)}
    />
  )

  const handleEditName = (item) => {
    createLayout('real', `${periodId}-${conceptId}`, item.name, {
      ...item,
      name: newName,
    })
      .then(() =>
        fetchLayoutList('real', `${periodId}-${conceptId}`).then(() => {
          message.success(t('FEEDBACK_CHANGES_SAVED_SUCCESS'), 8)
          setShowEdit(false)
          setRowId(false)
        }),
      )
      .catch((error) => {
        setShowEdit(false)
        setRowId(false)
        notification.error({
          message: t('FEEDBACK_DEFAULT_ERROR'),
          description: generateMessageError(error),
          duration: 0,
        })
      })
  }

  const onDelete = (item, { ...props }) => {
    handleDelete({
      setIsLoading: setIsSaving,
      deleteLayout: () => deleteLayout('real', `${periodId}-${conceptId}`, item.name),
      onRefetch: () => fetchLayoutList('real', `${periodId}-${conceptId}`),
      onClose: () => setIsSaving(false),
      ...props,
    })
  }

  const handleBeforeUnload = useCallback(() => {
    localStorage.removeItem('dataTable')
    setExist(false)
  }, [])

  return (
    <>
      <Prompt
        when={localStorage.getItem('dataTable')}
        message={(nextLocation) => {
          handleBeforeUnload()
          return true
        }}
      />
      <Row gutter={[8, 8]}>
        <Col span={24} style={{ display: 'flex', justifyContent: 'center' }}>
          {showProgressBar && <ProgressBar isLoading={isProgressLoading} />}
        </Col>
        <Col span={24}>{renderTableActions()}</Col>
        <Col span={24}>
          <ProjectionControlTable
            dataSource={dataSource.data}
            fields={dataSource.fields}
            isTableLoading={isTableLoading}
            settings={settings}
            setSettings={setSettings}
            hasComment={hasComment}
            setViewComment={setViewComment}
            setHasComment={setHasComment}
            setHash={setHash}
            setShowTableqp={setShowTableqp}
            conceptId={conceptId}
            periodId={periodId}
            currencyId={currencyData?.id}
          />
        </Col>
      </Row>
      <FavouriteEditModal
        visible={showModalEdit}
        onClose={() => setShowModalEdit(false)}
        dataSource={layoutList.values.filter((el) => !el.url_hash)}
        viewSelect={viewSelect}
        setIsSaving={setIsSaving}
        onSavePrimary={(item) => onSavePrimary(item)}
        onRefetch={() => fetchLayoutList('real', `${periodId}-${conceptId}`)}
        handleDelete={(item) => {
          if (layoutList.values.filter((el) => !el.url_hash).length > 1 && item.primary) {
            const filterItems = layoutList.values.filter(
              (el) => el.name !== item.name && !el.url_hash,
            )
            const newItem = filterItems[filterItems.length - 1]
            onDelete(item, {
              onSetPrimary: () =>
                createLayout('real', `${periodId}-${conceptId}`, newItem.name, {
                  ...newItem,
                  primary: true,
                }),
              setViewSelect: () => setViewSelect(newItem),
            })
          } else if (layoutList.values.filter((el) => !el.url_hash).length === 1) {
            onDelete(item, {
              onRefetch: () =>
                Promise.all([fetchLayoutList('real', `${periodId}-${conceptId}`), onRefresh()]),
              setSettings: () =>
                setSettings({
                  ...settings,
                  vals: ['amount'],
                  cols: ['Fecha'],
                  rows: ['Cuenta'],
                  aggregatorName: 'Suma (Decimales)',
                }),
            })
          } else {
            onDelete(item, {})
          }
        }}
        handleEditName={(item) => handleEditName(item)}
        showEdit={showEdit}
        setShowEdit={setShowEdit}
        rowId={rowId}
        setRowId={setRowId}
        newName={newName}
        setNewName={setNewName}
      />
      <DownloadModal
        title={INTEGRATIONS.KEYS.SPREADSHEETS_KEY}
        visible={showModal}
        onCancel={() => setShowModal(false)}
        defaultValue={loggedUser.folder_id}
        dataSpreadsheets={{
          type_load: 'seguimiento',
          params: {
            date_start: moment(dataPeriod?.start_date).format('YYYY-MM-DD'),
            date_end: moment(dataPeriod?.end_date).format('YYYY-MM-DD'),
            period_id: periodId,
            concept_id: conceptId,
          },
        }}
        sendUserDataToGTM={() =>
          sendUserDataToGTM(
            loggedUser,
            'Seguimiento',
            'Descargar por spreadsheet reales',
            'Descarga',
          )
        }
      />
      <PreferencesTableModal
        visible={showPreferenceModal}
        onClose={() => setShowPreferenceModal(false)}
        onRefresh={onRefresh}
        setShowPreferenceModal={setShowPreferenceModal}
        allDimensionsList={allDimensionsList}
      />
    </>
  )
}

const mapStateToProps = (state) => ({
  loggedUser: login.selectors.getWhoAmI(state),
  layoutList: control.selectors.getLayoutList(state),
  allDimensionsList: configuration.selectors.getAllDimensionsList(state),
  hasComment: configuration.selectors.getHasComment(state),
  commentsList: configuration.selectors.getCommentsList(state),
})

const mapDispatchToProps = {
  downloadProjectionXLS: control.actions.downloadProjectionXLS,
  createLayout: control.actions.createLayout,
  fetchLayoutList: control.actions.fetchLayoutList,
  fetchAllDimensions: configuration.actions.fetchAllDimensions,
  deleteTransactionFilter: control.actions.deleteTransactionFilterByControl,
  deleteLayout: control.actions.deleteLayout,
  setHasComment: configuration.actions.setHasComment,
  fetchCommentsList: configuration.actions.fetchCommentsList,
  createComment: configuration.actions.createComment,
  removeNewComment: configuration.actions.removeNewComment,
  downloadProjectionExcel: control.actions.downloadProjectionExcel,
  downloadProjectionParquet: control.actions.downloadProjectionParquet,
  downloadControlTableTsv: control.actions.downloadControlTableTsv,
}

export default connect(mapStateToProps, mapDispatchToProps)(Evolution)
